import { FC, useState } from 'react';
import { toast } from 'react-toastify';

import MagicLinkForm from './MagicLinkForm';
import MagicLinkSent from './MagicLinkSent';
import PasswordForm from './PasswordForm';

import { sendMagicLink } from '@/api/magicLink/magicLink.actions';
import { MagicLinkLoginData } from '@/api/magicLink/magicLink.types';
import Button from '@/components/controls/Button.tsx';
import { useMagicLinkStore } from '@/stores/useMagicLinkStore';

const MagicLinkSection: FC = () => {
  const linkSent = useMagicLinkStore((state) => state.linkSent);
  const email = useMagicLinkStore((state) => state.email);

  const onSubmit = async (data: MagicLinkLoginData): Promise<void> => {
    const response = await sendMagicLink(data);

    if (!response.success) {
      toast.error(response.error.message);
      return;
    }

    toast.success('Magic Link sent to email address');
  };

  return (
    <div>
      {linkSent ? (
        <MagicLinkSent email={email} resendLink={onSubmit} />
      ) : (
        <MagicLinkForm onSubmit={onSubmit} />
      )}
    </div>
  );
};

const LoginForm: FC = () => {
  const [magicLinkLogin, setMagicLinkLogin] = useState<boolean>(false);

  const toggleLoginMethod = (): void => {
    setMagicLinkLogin((prev) => !prev);
  };

  return (
    <div className="self-center w-[calc(100vw-2rem)] max-w-[400px] md:max-w-[450px] fluid-desktop:max-w-[500px] xl:max-w-[650px] fluid-desktop:w-[40vw] xl:w-[30vw] min-w-0 nest-hub-form-width">
      {magicLinkLogin ? <MagicLinkSection /> : <PasswordForm />}

      <Button
        buttonStyle="w-full px-6 py-2 mt-4 text-lg font-semibold text-honoursOrange bg-white rounded-xl border border-honoursOrange"
        text={
          magicLinkLogin
            ? 'Switch to Login with Password'
            : 'Switch to Login with Magic Link'
        }
        buttonType={{ type: 'button' }}
        hasImage={false}
        onClick={toggleLoginMethod}
      />
    </div>
  );
};

export default LoginForm;
